module.exports = __webpack_public_path__ + "img/Gift_Box_Light.9d106c12.png";